<template>
  <TopbarSpeedDial :buttons="buttons" :routeKey="routeKey"/>
</template>


<script>
/* @flow */
const TopbarSpeedDial = () =>
  import(/* webpackChunkName: "TopbarSpeedDial" */ '@/components/TopbarSpeedDial')

export default {
  name: 'DeviceProfileSpeedDial',
  props: {
    routeName: {type: String, default: ''},
    routeKey: {type: String, default: ''},
  },
  data() {
    return {
      buttonsConfig: [
        {
          label: 'Create Device Profile',
          icon: 'add',
          showForDeviceProfilesScreen: true,
          colorClass: 'accent',
          to: 'new',
        },
      ],
    }
  },
  computed: {
    buttons: function() {
      if (this.routeName.startsWith('DeviceProfiles')) {
        return this.buttonsConfig.filter(btn => btn.showForDeviceProfilesScreen)
      } else {
        return this.buttonsConfig
      }
    },
  },
  components: {
    TopbarSpeedDial,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/DeviceProfileSpeedDial.vue